(function ($, Drupal) {
  Drupal.behaviors.spacer = {
    attach: function spacer(context, settings) {
      if (typeof context['location'] !== 'undefined') {
        function setMinHeight() {
          var screenWidth = $(window).width();
          var spacerBlocks = $('.block--spacer');
          var spacing = 0;

          // These values should always match the values from web/themes/custom/mount_allison/src/010_sass-config/layout/_breakpoints.scss.
          var breakpoints = {
            fallback: 0,
            small: 320,
            land: 568,
            med: 768,
            large: 1024,
            larger: 1366,
            wide: 1500
          };

          $.each(spacerBlocks, function (index) {
            if (screenWidth >= breakpoints.fallback && screenWidth < breakpoints.small) {
              spacing = $(this).attr('data-fallback');
            }
            else if (screenWidth >= breakpoints.small && screenWidth < breakpoints.land) {
              spacing = $(this).attr('data-small');
            }
            else if (screenWidth >= breakpoints.land && screenWidth < breakpoints.med) {
              spacing = $(this).attr('data-land');
            }
            else if (screenWidth >= breakpoints.med && screenWidth < breakpoints.large) {
              spacing = $(this).attr('data-med');
            }
            else if (screenWidth >= breakpoints.large && screenWidth < breakpoints.larger) {
              spacing = $(this).attr('data-large');
            }
            else if (screenWidth >= breakpoints.larger && screenWidth < breakpoints.wide) {
              spacing = $(this).attr('data-larger');
            }
            else {
              spacing = $(this).attr('data-wide');
            }

            $(this).css("min-height", spacing);
          });
        }

        setMinHeight();
        var minHeightDebounce = Drupal.debounce(function() {
          setMinHeight();
        }, 250);
        window.addEventListener('resize', minHeightDebounce);
      }
    }
  };
})(jQuery, Drupal, window, document);
